import React from 'react';
import { intlShape } from 'common/components/intl/intlShape';

import LocalizedDayjs from 'common/localized_dayjs';
import { age } from 'common/utils';
import DobWarningModal from 'apps/age_verification/components/forms/DobWarningModal';
import PropTypes from 'apps/age_verification/propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import WarrantyOnlyWarning from 'apps/age_verification/components/WarrantyOnlyWarning';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Fields from 'apps/age_verification/components/forms/Fields';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from 'apps/age_verification/messages';

class SimpleFormDobFieldGroup extends React.Component {
  static contextTypes = {
    intl: intlShape,
  };

  static propTypes = {
    minRequiredAge: PropTypes.number.isRequired,
    minPurchaseAge: PropTypes.number,
    selectedValues: PropTypes.object,
    disabled: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    this.localeDateFormat = LocalizedDayjs.getLocaleDateFormat(
      this.context.intl.locale,
      'L'
    );
    this.state = {
      isModalOpen: false,
      acknowledged: false,
    };
  }

  // Renders date fields in the order specified by locale's long date format
  renderDateFields() {
    const { year } = this.props.selectedValues;
    const dateFields = {
      m: <Fields.Month disabled={this.props.disabled} />,
      d: <Fields.Day disabled={this.props.disabled} />,
      y: (
        <Fields.Year
          disabled={this.props.disabled}
          minRequiredAge={this.props.minRequiredAge}
          selectedValue={year}
        />
      ),
    };

    const separator = format =>
      ['/', '.', '-'].filter(s => format.indexOf(s) > -1);
    const dateFieldKeys = this.localeDateFormat
      .split(separator(this.localeDateFormat))
      .map(component => component.toLowerCase().charAt(0));

    return (
      <div className="DobFieldGroup__fields row">
        {dateFieldKeys.map(key => (
          <div className="col-xs-4" key={key}>
            {dateFields[key]}
          </div>
        ))}
      </div>
    );
  }

  shouldWarn() {
    const { minRequiredAge, minPurchaseAge } = this.props;
    if (
      !this.selectedDob ||
      this.state.acknowledged ||
      minRequiredAge === minPurchaseAge
    ) {
      return false;
    }

    return age(this.selectedDob) < minPurchaseAge;
  }

  get selectedDob() {
    const { year, month, day } = this.props.selectedValues;
    if (!year || !month || !day) {
      return null;
    }

    return [year, month, day].join('-');
  }

  onModalClose() {
    this.setState({ acknowledged: true });
  }

  render() {
    return (
      <div className="DobFieldGroup AddressForm__group">
        <div className="AddressForm__group-title">
          <TranslatedMessage id={m.DOB_TITLE} />
        </div>
        <p className="text flat-blue AddressForm__group-description">
          <TranslatedMessage id={m.DOB_DESCRIPTION} />
        </p>

        {this.renderDateFields()}

        <WarrantyOnlyWarning
          minPurchaseAge={this.props.minPurchaseAge}
          dateOfBirth={this.selectedDob}
        />

        <DobWarningModal
          isOpen={this.shouldWarn()}
          onClose={this.onModalClose.bind(this)}
          age={this.props.minPurchaseAge}
        />
      </div>
    );
  }
}

export default SimpleFormDobFieldGroup;
